import TermlyCookieBanner from '@m/components/TermlyCookieBanner/TermlyCookieBanner';
import Providers from '@m/providers';

import Pay from './Pay';
import { GlobalStyles } from './Pay.styled';

export function PayApp() {
  return (
    <Providers>
      <TermlyCookieBanner />
      <Pay />
      <GlobalStyles />
    </Providers>
  );
}
